import { render, staticRenderFns } from "./MemoModal.vue?vue&type=template&id=2b371a11&scoped=true"
import script from "./MemoModal.vue?vue&type=script&lang=js"
export * from "./MemoModal.vue?vue&type=script&lang=js"
import style0 from "./MemoModal.vue?vue&type=style&index=0&id=2b371a11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b371a11",
  null
  
)

export default component.exports